// extracted by mini-css-extract-plugin
export default {"wrapper__divider":"OtpInput_wrapper__divider__fw785"};